Vue.component("item-variation-select-tag", {
  template: "#vue-item-variation-select-tag",
  props: {
    disabled: Boolean,
    group: Object,
    value: String,
    displaySelectCount: {
      type: Number,
      default: 7,
    },
    description: String,
    highlight: Boolean,
    grid: Boolean,
  },
  data: () => ({}),
  methods: {
    selectTag (option) {
      const { label, stats: { matchesTags } } = option;
      this.$emit("input", label, !matchesTags);
    },
    showStats (option, group, selected = false, separator = ', ') {
      const { displayStats, selectedDisplayStats, displayStatsMaxCount } = group;
      const { stats } = option;
      const result = [];

      for (let key of (selected ? selectedDisplayStats : displayStats)) {
        if (stats[key]) {
          result.push(stats[key]);
        }

        if (displayStatsMaxCount && result.length >= displayStatsMaxCount) {
          break;
        }
      }

      return result.join(separator);
    },
    getTitle (option) {
      if (option.disabled) {
        return 'Artikelvariante nicht vorhanden';
      } else if (option.stats.matchesTags) {
        if (!option.stats.hasStock) {
          return 'Bald wieder da - Jetzt Kaufalarm aktivieren!';
        } else {
          return '';
        }
      } else {
        return 'Nur in Kombination mit anderen Merkmalen verfügbar.';
      }
    },
    getVersionFlag (option) {
      switch (option.label) {
        case "ARA Version":
        case "ARAB Version":
        case "ARE Version":
        case "UAE Version":
          return '/images/beta/images/layout/artikel_img/Arabisch.png';
        case "AT Import":
        case "AT Version":
        case "CH Import":
        case "CHE Version":
        case "CHE Version":
        case "DE Version":
          return '/images/beta/images/layout/artikel_img/Deutsch.png';
        case "CHN Import":
        case "CHN Version":
        case "HK Import":
        case "HK Version":
        case "HKG Import":
        case "HKG Version":
          return '/images/beta/images/layout/artikel_img/Chinesisch.png';
        case "DK Version":
        case "DNK Version":
          return '/images/beta/images/layout/artikel_img/Dänisch.png';
        case "CAN Import":
        case "CAN Version":
        case "UK Import":
        case "UK Version":
        case "US Import":
        case "US Version":
          return '/images/beta/images/layout/artikel_img/Englisch.png';
        case "BEL Version":
        case "BNL Import":
        case "BNL Version":
        case "CZ Version":
        case "CZE Version":
        case "GRC Version":
        case "HUN Version":
        case "SK Version":
        case "SVK Version":
        case "EU Version":
          return '/images/beta/images/layout/artikel_img/Europa.png';

        case "FIN Import":
        case "FIN Version":
          return '/images/beta/images/layout/artikel_img/Finnisch.png';
        case "FR Import":
        case "FR Version":
        case "FRA Import":
        case "FRA Version":
          return '/images/beta/images/layout/artikel_img/Französisch.png';
        case "HOL Version":
          return '/images/beta/images/layout/artikel_img/Holländisch.png';
        case "IT Version":
        case "ITA Import":
        case "ITA Version":
          return '/images/beta/images/layout/artikel_img/Italienisch.png';
        case "JAP Import":
        case "JAP Version":
          return '/images/beta/images/layout/artikel_img/Japanisch.png';
        case "NL Version":
        case "NLD Import":
        case "NLD Version":
          return '/images/beta/images/layout/artikel_img/Niederländisch.png';
        case "NOR Version":
          return '/images/beta/images/layout/artikel_img/Norwegisch.png';
        case "POL Import":
        case "POL Version":
          return '/images/beta/images/layout/artikel_img/Polnisch.png';
        case "BRA Import":
        case "BRA Version":
        case "PORT Version":
        case "PRT Import":
        case "PRT Version":
          return '/images/beta/images/layout/artikel_img/Portugiesisch.png';
        case "RU Version":
        case "RUS Import":
        case "RUS Version":
          return '/images/beta/images/layout/artikel_img/Russisch.png';
        case "ESP Import":
        case "ESP Version":
          return '/images/beta/images/layout/artikel_img/Spanisch.png';
        case "SWE Version":
          return '/images/beta/images/layout/artikel_img/Schwedisch.png';
        case "AU Version":
        case "AUS Import":
        case "AUS Version":
        case "KOR Import":
        case "KOR Version":
        case "PEGI Version":
        case "SAU Version":
        case "SCA Version":
        case "SCN Import":
        case "SCN Version":
        case "SGP Import":
        case "SGP Version":
        case "SNC Version":
        case "TR Version":
        case "TUR Version":
          return "";
      }
    },
  },
});
